<template>
  <v-container fluid style="margin-bottom: 6rem;">
    <v-row align="center" justify="center" no-gutters>
      <span class="features-page-title">Fonctionnalités</span>
    </v-row>
    <v-row align="center" justify="center" no-gutters>
      <div class="features-title-div">
        <span class="features-title"
          >Découvrez comment <br />
          Geskitchen peut vous aider</span
        >
      </div>
    </v-row>
    <v-row align="center" justify="center" no-gutters class="mt-2">
      <v-icon small>fa-chevron-down</v-icon>
    </v-row>
    <v-container style="margin-top: 4rem;">
      <v-row align="center" class="row-margin">
        <v-spacer></v-spacer>
        <v-col cols="12" sm="6" md="4">
          <span class="features-section-title"
            >Mise à jour d’inventaires automatique</span
          >
          <p class="features-section-text">
            Apprenez avec une grande précision la quantité restante de chaque
            aliment et de chaque préparation contribuant au succès de vos
            recettes. Le retrait automatique des produits utilisés ou perdus et
            l’ajout de ceux réapprovisionnés concourent à vous donner l’heure
            juste d’une consultation à l’autre.
          </p>
        </v-col>
        <v-col cols="0" sm="6" md="7" v-if="$vuetify.breakpoint.smAndUp">
        </v-col>
      </v-row>
      <v-row align="center" class="row-margin">
        <v-col cols="0" sm="6" md="7" v-if="$vuetify.breakpoint.smAndUp">
          <div
            style="position: relative;
          height: 400px;"
          >
            <div class="features-design"></div>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <span class="features-section-title">Optimisation du cost</span>
          <p class="features-section-text">
            Puisque chaque transformation reposera sur des recettes
            minutieusement quantifiées, pas de pertes ni d’utilisation excessive
            en vue avec GesKitchen. Calculez votre cost de la manière la plus
            efficace qui soit et veillez à la réduction de votre inventaire,
            maintenant mieux adapté à vos besoins.
          </p>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row align="center" class="row-margin">
        <v-spacer></v-spacer>
        <v-col cols="12" sm="6" md="4">
          <span class="features-section-title"
            >Livre de recettes souple et adapté</span
          >
          <p class="features-section-text">
            Permettra à vos cuisiniers de reproduire étape par étape et à la
            perfection l’étendue entière de vos recettes, modifiables par vous
            au gré des saisons ou de l’inspiration. GesKitchen vous guidera dans
            la préparation de vos spécialités, du frigo à l’assiette!
          </p>
        </v-col>
        <v-col cols="0" sm="6" md="7" v-if="$vuetify.breakpoint.smAndUp">
          <v-row align="center" justify="center" no-gutters dense>
            <svg width="360" height="360">
              <circle cx="180" cy="180" r="180" fill="rgba(0, 0, 0, 0.03)" />
            </svg>
          </v-row>
        </v-col>
      </v-row>
      <v-row align="center" class="row-margin">
        <v-col
          cols="0"
          sm="6"
          md="7"
          v-if="$vuetify.breakpoint.smAndUp"
        ></v-col>
        <v-col cols="12" sm="6" md="4">
          <span class="features-section-title">Allergènes</span>
          <p class="features-section-text">
            Alors qu’ils constituent une source constante de stress dans la
            cuisine comme dans la salle à manger, les aliments allergènes seront
            clairement indiqués dans GesKitchen, pour chacune de vos recettes.
            Vous pourrez ainsi accompagner intelligemment votre clientèle dans
            leur choix de repas, et la laisser déguster sans inquiétude.
          </p>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row align="center" class="row-margin">
        <v-spacer></v-spacer>
        <v-col cols="12" sm="6" md="4">
          <span class="features-section-title"
            >Meilleure organisation de la cuisine</span
          >
          <p class="features-section-text">
            GesKitchen offre la possibilité de visualiser une disposition des
            aliments et des emballages calquant celle de votre cuisine (tables
            froides, étagères, frigos, congélateurs)! Le tout favorisera un
            travail efficient de votre part et de celle de vos cuisiniers.
          </p>
        </v-col>
        <v-col cols="0" sm="6" md="7" v-if="$vuetify.breakpoint.smAndUp">
          <div
            style="position: relative;
          height: 400px;"
          >
            <div class="features-design-reverse"></div>
          </div>
        </v-col>
      </v-row>
      <v-row align="center" class="row-margin">
        <v-col cols="0" sm="6" md="7" v-if="$vuetify.breakpoint.smAndUp">
          <v-row align="center" justify="center" no-gutters dense>
            <svg width="360" height="360">
              <circle cx="180" cy="180" r="180" fill="rgba(0, 0, 0, 0.03)" />
            </svg>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <span class="features-section-title"
            >Suivi plus facile pour la direction</span
          >
          <p class="features-section-text">
            Quittez le restaurant l’esprit tranquille, GesKitchen prend votre
            relais! Du bout des doigts, sachez en tout temps ou à votre retour
            au travail l’état de votre inventaire, de vos ventes et de vos
            commandes. Pensez saveurs, pensez expérience, on s’occupe du reste!
          </p>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: "Features"
};
</script>

<style lang="scss" scoped>
.row-margin {
  margin-top: 3rem;
}
.features-page-title {
  font-size: 0.8rem;
  font-weight: 500;
  letter-spacing: 1px;
}
.features-title-div {
  margin: 2rem 0;
  text-align: center;
  .features-title {
    font-size: 3rem;
    font-weight: 500;
    line-height: 1;
  }
}
.features-section-title {
  font-size: 2.5rem;
  font-weight: 500;
  line-height: 1;
}
.features-section-text {
  margin-top: 2rem;
  font-size: 1rem;
  letter-spacing: 1px;
  opacity: 0.9;
}
.features-design {
  position: absolute;
  top: 0;
  width: 100vw;
  left: -60vw;
  height: 340px;
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 0 0 50rem 0;
}
.features-design-reverse {
  position: absolute;
  top: 0;
  width: 100vw;
  right: -60vw;
  height: 340px;
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 0 0 0 50rem;
}
@media screen and (min-width: 1500px) {
  .features-design {
    left: -75vw;
  }
  .features-design-reverse {
    right: -75vw;
  }
}
</style>
